module.exports = __webpack_public_path__ + "static/media/namninsamling.b0fea399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/namninsamling.png
// module id = 121
// module chunks = 0